
const NotFound = () => <div style={{minHeight: '100vh'}}>NotFound</div>;

export default NotFound;